// @flow
import {CardText} from "material-ui/Card"
import {Link} from "react-router-dom"
import {Toolbar, ToolbarGroup, ToolbarTitle} from "material-ui/Toolbar"
import {containers} from "@swarm2/core"
import withProps from "recompose/withProps"
import compose from "recompose/compose"
import EditIcon from "material-ui/svg-icons/editor/mode-edit"
import IconButton from "material-ui/IconButton"
import * as React from "react"
import * as Util from "../common"

const M = Util.intlMessages("view.UserView")

function BaseUserRender(props) {
  if (props.isError) return <Util.Error error={props} />
  const {
    displayName,
    createdAt,
    toolbarActions,
    header,
    preferYou = false,
  } = props
  const yousername = preferYou ? "You" : displayName
  const toolbar = (
    <Toolbar>
      <ToolbarGroup>
        <ToolbarTitle text={displayName} />
        {toolbarActions}
      </ToolbarGroup>
    </Toolbar>
  )
  return (
    <div>
      {toolbar}
      <CardText>
        {header}
        <p>
          <M
            id={"created"}
            values={{
              username: yousername,
              ago: <Util.FromNow since={createdAt} />,
            }}
          />
        </p>
      </CardText>
    </div>
  )
}

const AuthUserRender = props => {
  const {promptUsername} = props
  return (
    <BaseUserRender
      {...props}
      preferYou={true}
      toolbarActions={
        <IconButton onClick={promptUsername}>
          <EditIcon />
        </IconButton>
      }
      header={
        <div>
          <p>
            <Link to={"/u/" + props.userId}>
              <M id={"publicprofile"} />
            </Link>
          </p>
          <p>
            <Link to={"/me/characters"}>
              <M id={"mycharacters"} />
            </Link>
          </p>
        </div>
      }
    />
  )
}
export const AuthUserView = compose(
  containers.users.AuthUser,
  withProps(props => ({
    promptUsername: event => {
      const name = prompt("Your new name: ")
      // name is null on prompt cancel
      if (name !== null) props.setUsername(name)
    },
  })),
  Util.DumpProps,
)(AuthUserRender)

export const UserRender = (props: *) => {
  return (
    <BaseUserRender
      {...props}
      header={
        <div>
          <p>
            <Link to={"/u/" + props.userId + "/characters"}>
              <M id="characterlist" />
            </Link>
          </p>
        </div>
      }
    />
  )
}
export const UserView = containers.users.User(Util.DumpProps(UserRender))



// WEBPACK FOOTER //
// ./src/users/UserView.js